<template>
    <div id="app">
        <div class="app-aura app-aura-left"></div>
        <div class="app-aura app-aura-right"></div>

        <main class="app-main">
            <router-view/>
        </main>

        <div class="footer-nav">
            <div class="nav-item" :class="{ active: $route.name === 'Home' }" @click="goPage('/')">
                <van-icon name="home-o" />
                <span>首页</span>
            </div>
            <div class="nav-item" :class="{ active: $route.name === 'video' || $route.name === 'videoPlay' }" @click="goPage('/video')">
                <van-icon name="play-circle-o" />
                <span>视频</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        goPage(path) {
            this.$router.push(path)
        }
    }
}
</script>

<style lang="less">
:root {
    --a-bg: #f7f3e9;
    --a-surface: rgba(255, 255, 255, 0.78);
    --a-primary: #0f5964;
    --a-secondary: #dd6f24;
    --a-text: #222222;
    --a-muted: #6f6860;
    --a-shadow: 0 16px 34px rgba(40, 31, 12, 0.14);
    --a-radius: 1.1rem;
}

* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

body {
    font-family: "Trebuchet MS", "PingFang SC", "Microsoft YaHei", sans-serif;
    font-size: 1.5rem;
    color: var(--a-text);
    background:
        radial-gradient(circle at 12% 8%, rgba(15, 89, 100, 0.26) 0, transparent 32%),
        radial-gradient(circle at 90% 0%, rgba(221, 111, 36, 0.25) 0, transparent 30%),
        linear-gradient(180deg, #f4efe2 0%, #faf7f0 46%, #f5f0e6 100%);
}

html,
body {
    height: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}

a {
    text-decoration: none;
}

img {
    border: 0;
    vertical-align: middle;
}

em,
i {
    font-style: normal;
}

li {
    list-style: none;
}

button {
    cursor: pointer;
}

@media screen and (min-width: 320px) {
    html {
        font-size: 65% !important;
    }
}

@media screen and (min-width: 750px) {
    html {
        font-size: 100% !important;
    }
}

#app {
    position: relative;
    width: 100%;
    max-width: 750px;
    min-height: 100vh;
    margin: 0 auto;
    padding: .75rem .75rem 6rem;
    overflow: hidden;
}

.app-aura {
    position: absolute;
    border-radius: 50%;
    filter: blur(4px);
    z-index: 0;
    pointer-events: none;
}

.app-aura-left {
    width: 12rem;
    height: 12rem;
    left: -3.5rem;
    top: 2rem;
    background: rgba(15, 89, 100, 0.26);
}

.app-aura-right {
    width: 14rem;
    height: 14rem;
    right: -5rem;
    top: 14rem;
    background: rgba(221, 111, 36, 0.2);
}

.app-main {
    position: relative;
    z-index: 1;
}

.footer-nav {
    position: fixed;
    left: 50%;
    bottom: .45rem;
    transform: translateX(-50%);
    width: calc(100% - 1.4rem);
    max-width: 730px;
    display: flex;
    padding: .25rem;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.93);
    border: 1px solid rgba(15, 89, 100, 0.18);
    box-shadow: 0 14px 28px rgba(27, 41, 45, 0.22);
    z-index: 999;

    .nav-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: .2rem;
        text-align: center;
        padding: .55rem 0;
        color: #4f5a5d;
        font-size: .96rem;
        border-radius: 999px;
        transition: all .25s ease;

        .van-icon {
            font-size: 1.3rem;
            line-height: 1;
        }

        &.active {
            background: linear-gradient(135deg, var(--a-primary), #2f8b98);
            color: #fff;
            font-weight: 700;
            box-shadow: inset 0 -2px 0 rgba(255, 255, 255, .24);
        }
    }
}
</style>